var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"page_padding top-banner"},[_c('span',{staticClass:"banner-title fontBold"},[_vm._v(_vm._s(_vm.subTitle))]),(_vm.subImg !== undefined)?_c('image-component',{attrs:{"path":"","is_jpg":false,"name":_vm.subImg}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }